import {forEach} from "lodash/collection";
import table from "./table";

let incrementer = 0;
let values_incrementers = [];
let total = 0;
let cart = [];
let list_customers = [];
let customer_id = 0;
let order_id = 0;
let signature = null;
export default {
    init() {
        this.initTable();
        this.initModal();
        this.initOrderAdd();
        this.initPay();
        this.initOrderEdits();
        this.initOrderDeletes();
        this.initCancelOrder();
        this.initPrintReceipt();
        this.initSendReceipt();
        this.initProducts();
        this.initDiscount();
        this.getModalWithModifiers();
        this.initQuantity('plus');
        this.initQuantity('minus');
        this.addToCart();
        this.removeFromCart();
        this.enterManually();
        this.pay();
        this.refund();
        this.payFromMyOrders();
        this.setTips();
        this.hideSignPlaceholder();
        this.saveTips();
        this.checkedCash();
    },
    initTable() {
        if ($('#order_table').length) {
            $('#order_table').ready(function () {
                let customer_type = $('#add-order-form input[name="type"]').val();
                $.ajax({
                    type: 'GET',
                    url: '/get_orders',
                    data: ({
                        type: customer_type
                    }),
                    success: function (response) {
                        if(window.location.pathname !== '/admin/leads' && window.location.pathname !== '/admin/settings') {
                            $('#order_table').html(response);
                            $('#order_table #table').DataTable({
                                ajax: {
                                    type: 'GET',
                                    url: '/get_orders_for_datatable',
                                    data: ({
                                        type: customer_type,
                                    }),
                                },
                                columns: [
                                    {'data': 'customer.id'},
                                    {
                                        'data': 'Customer',
                                        render: function (data, type, row) {
                                            if (customer_type === 'organisation') {
                                                return row.customer.organisation_name;
                                            }
                                            let last_name = row.customer.last_name;
                                            if (last_name === null) last_name = '';
                                            return row.customer.first_name + ' ' + last_name;
                                        }
                                    },
                                    {'data': 'customer.phone'},
                                    {'data': 'store_number'},
                                    {'data': 'order_number'},
                                    {'data': 'date'},
                                    {'data': 'status'},
                                    {'data': 'total'},
                                    {'data': 'weight'},
                                    {
                                        'data': 'Products',
                                        render: function (date, type, row) {
                                            let products = '<div>';
                                            if (row.products.length) {
                                                products += '<button class="btn btn-primary" type="button" data-toggle="collapse" data-target="#product-' + row.id + '" aria-expanded="false" aria-controls="product-' + row.id + '">Show / Hide products</button>';
                                                products += '<div class="collapse" id="product-' + row.id + '">';
                                                row.products.forEach(function (item) {
                                                    let product = item.product[0];
                                                    products += product.title + '<ul>';
                                                    if (product.modifiers) {
                                                        for (let i = 0; i < product.modifiers.length; i++) {
                                                            products += '<li>' + product.modifiers[i].title + ':<br>';
                                                            forEach(product.modifiers[i].selected, function (value) {
                                                                let price = product.modifiers[i].values[value].price;
                                                                products += product.modifiers[i].values[value].title + ' ('
                                                                if (price < 0) products += '−';
                                                                products += '$' + Math.abs(price) + ')' + '<br>';
                                                            });
                                                            products += '</li>';
                                                        }
                                                    }
                                                    products += '</ul>';
                                                    products += 'Quantity: ' + item.quantity + '<br class="mb-4">';
                                                });
                                                products += '</div>';
                                            }
                                            products += '</div>';
                                            return products;
                                        }
                                    },
                                    {
                                        'data': 'Discount',
                                        render: function (date, type, row) {
                                            let discount = '<div>';
                                            if (row.discount_amount !== null) {
                                                discount += '<button class="btn btn-primary" type="button" data-toggle="collapse" data-target="#discount-' + row.id + '" aria-expanded="false" aria-controls="discount-' + row.id + '">Show / Hide discount</button>';
                                                discount += '<div class="collapse" id="discount-' + row.id + '">';
                                                discount += 'Discount: ';
                                                if (row.discount_type === 'amount') discount += '$';
                                                discount += row.discount_amount;
                                                if (row.discount_type === 'percent') discount += '%';
                                                discount += '<br>Reason: ' + row.discount_reason;
                                                discount += '</div>';
                                            }
                                            discount += '</div>';
                                            return discount;
                                        }
                                    },
                                    {
                                        'data': 'Action',
                                        render: function (data, type, row) {
                                            return '<div class="btn-group"><a href="#" class="btn btn-primary order-edit" data-id="' + row.id + '"><i class="fa fa-pencil"></i></a>' +
                                                '<a href="#" class="btn btn-danger order-delete" data-id="' + row.id + '"><i class="fa fa-trash"></i></a>' +
                                                '<a href="#" class="btn btn-info print-order-receipt" data-id="' + row.id + '"><i class="fa fa-print"></i></a>' +
                                                '<a href="#" class="btn btn-info send-order-receipt" data-id="' + row.id + '"><i class="fa fa-envelope"></i></a></div>';
                                        }
                                    }
                                ],
                                "columnDefs": [{
                                    "targets": 11,
                                    "searchable": false,
                                    "orderable": false
                                }]
                            });
                        }
                    }
                });
            });
        }
    },
    initModal() {
        let $this = this;
        $('.add-order').click(function () {
            $('#add-order-form')[0].reset();
            $('#add-order-form input[name="id"]').val('');
            $('#add-order-form #div-order-number').hide();
            $('#discount_checkbox').prop('checked', false);
            $('#add-order-form #discount').hide();
            $('#order-products-wrapper').html('');
            $('.add-order-form-wrapper .form-validation-errors').html('');
            incrementer = 0;
            values_incrementers = [];
            $('#order-date').datetimepicker({
                maxDate: new Date(),
                format: 'YYYY-MM-DD HH:mm:ss',
            });
            $this.recountTotals();
        });
    },
    initOrderAdd() {
        let $this = this;
        if ($('#add-order-form').length) {
            $('body').on('click', '#add-order-submit-form', function (e) {
                // let data = $('#add-order-form').serialize() + '&total=' + total;
                let form = $('#add-order-form')[0];
                let timestamp = Math.floor(new Date($(form.date).val()).getTime()/1000);
                $(form.date).val(timestamp);
                $(form.total).val(total);
                let data = new FormData(form);

                e.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: '/orders',
                    data: data,
                    processData: false,
                    contentType: false,
                    success: function () {
                        $('#order_products_modal').modal('hide');
                        $('#add-order-modal').modal('hide');
                        $('#add-order-form')[0].reset();
                        $('.add-order-form-wrapper .form-validation-errors').empty();
                        $('#order_table #table').DataTable().ajax.reload(null, false);
                        $this.recountTotals();
                        setTimeout(function () {
                            table.updateMyOrdersTable();
                        }, 500);
                    },
                    error: function (response) {
                        if (response.responseJSON.error) {
                            $('.add-order-form-wrapper .form-validation-errors').html('<div class="alert alert-danger">' + response.responseJSON.error + '</div>');
                        }
                        if (response.responseJSON.errors) {
                            let errorsHtml = '<div class="alert alert-danger">Some errors occurred:<br /><ul>';

                            $.each(response.responseJSON.errors, function (index, value) {
                                errorsHtml += '<li>' + value + '</li>';
                            });
                            errorsHtml += '</ul></div>';

                            $('.add-order-form-wrapper .form-validation-errors').html(errorsHtml);
                        }
                    }
                });
            });
        }
        $('body').on('click', '.cart .products .btn-complete', function (e) {
            e.preventDefault();
            $this.saveOrder('Not paid');
            $('#pay_order_modal #pay_order_modal_form')[0].reset();
            $('#tips input[name="card_id"]').val('');
            setTimeout(function () {
                $('#pay_order_modal_form button.print-order-receipt').attr('data-id', order_id);
                $('#pay_order_modal').modal('show');
            }, 200);
        });
        $('body').on('keyup', '#pay_order_modal_form input', function () {
            let fields = ['first_name', 'last_name', 'phone'];
            let input_name = $(this).attr('name');
            $.ajax({
                type: 'POST',
                url: '/get_list_customers',
                data: ({
                    fields: fields,
                    search: $(this).val(),
                }),
                success: function (response) {
                    if (response.length > 0) {
                        list_customers = response;
                        let customers = '<div class="customers">';
                        response.forEach(function (customer, index) {
                            customers += '<div class="customer" data-index="' + index + '">' + customer[input_name] + '</div>';
                        });
                        customers += '</div>';
                        $('#pay_order_modal_form .customers-' + input_name).html(customers);
                    }
                },
            });
        });
        $('body').on('click', '#pay_order_modal_form .customer', function (e) {
            e.preventDefault();
            let customer = list_customers[$(this).data('index')];
            $('#pay_order_modal_form input[name="name"]').val(customer['name']);
            $('#pay_order_modal_form input[name="phone"]').val(customer['phone']);
        });
        $('body').on('focus', '#pay_order_modal_form input', function () {
            let input_name = $(this).attr('name');
            $('#pay_order_modal_form .customers-' + input_name).css('display', 'block');
        });
        $('body').on('focusout', '#pay_order_modal_form input', function () {
            setTimeout(() => {
                let input_name = $(this).attr('name');
                $('#pay_order_modal_form .customers-' + input_name).css('display', 'none');
            }, 200);
        });
    },
    saveCashFromOrder() {
        let $this = this;
        // ledger row via the retired-POS replacement endpoint; status + receipt as before
        $.ajax({
            type: 'POST',
            url: '/record-order-cash-payment',
            data: ({ order_id: order_id }),
            success: function () {
                $.ajax({
                    type: 'POST',
                    url: '/change_order',
                    data: ({ status: 'Paid', order_id: order_id }),
                    success: function () {
                        window.open('/print-order-receipt/' + order_id);
                    }
                });
            }
        });
        $('#pay_order_modal').modal('hide');
        $this.successfully('show modal');
        setTimeout(function () {
            location.reload();
        }, 5000);
    },
    initPay() {
        let $this = this;
        $('body').on('submit', '#pay_order_modal_form', function (e) {
            e.preventDefault();
            let method = $('input[name="payment"]:checked').val();
            let name = $('input[name="name"]').val();
            let phone = $('input[name="phone"]').val();
            customer_id = 0;
            switch (method) {
                case 'card':
                    $.ajax({
                        type: 'POST',
                        url: '/get_customer_cards',
                        data: ({
                            name: name,
                            phone: phone,
                            order_id: order_id,
                        }),
                        success: function (response) {
                            $('#customer_cards_modal').html(response.view);
                            setTimeout(function(){
                                $('#auto-set-card').focus();
                            }, 500);
                            $('#' + response.id).modal('show');
                            if (response.customer_id) {
                                customer_id = response.customer_id;
                            }
                            let already_match = false;
                            let not_match = false;
                            $('#auto-set-card').on('keyup', function(e) {
                                let match = $(this).val().match(/B(\d+)\^(\w+\/\w+)(\s+?)?\^(\d\d)(\d\d)/);
                                if(match) {
                                    if ( ! already_match ) {
                                        let card_number = match[1];
                                        let card_exp = match[5] + '/' + match[4];
                                        already_match = true;
                                        $this.inTheProcess();
                                        $this.payEnter(card_number, card_exp);
                                    }
                                }else{
                                    if ( ! not_match ) {
                                        let error = 'Something went wrong! Please enter card manually.'
                                        $this.rejected(error, 'show modal');
                                        not_match = true;
                                    }

                                }
                            });
                        }
                    });
                    break;
                case 'cash':
                    if (name !== '' && phone !== '') {
                        $.ajax({
                            type: 'POST',
                            url: 'create_new_customer',
                            data: ({
                                name: name,
                                phone: phone,
                                type: 'private',
                            }),
                            success: function (response) {
                                customer_id = response.customer_id;
                                $.ajax({
                                    type: 'POST',
                                    url: 'change_order',
                                    data: ({
                                        status: 'Not paid',
                                        order_id: order_id,
                                        customer_id: response.customer_id,
                                    }),
                                    success: function () {
                                        $this.saveCashFromOrder();
                                    }
                                });
                            }
                        });
                    } else {
                        $this.saveCashFromOrder();
                    }
                    break;
            }
        });
        $('body').on('click', '#pay_order_modal_form .pay-later', function (e) {
            e.preventDefault();
            let name = $('input[name="name"]').val();
            let phone = $('input[name="phone"]').val();
            if (name === '') $('input[name="name"]').focusin();
            else if (phone === '') $('input[name="phone"]').focusin();
            else {
                $.ajax({
                    type: 'POST',
                    url: 'create_new_customer',
                    data: ({
                        name: name,
                        phone: phone,
                        type: 'private',
                    }),
                    success: function (response) {
                        customer_id = response.customer_id;
                        $.ajax({
                            type: 'POST',
                            url: 'change_order',
                            data: ({
                                status: 'Not paid',
                                order_id: order_id,
                                customer_id: response.customer_id,
                            })
                        });
                        $('#pay_order_modal').modal('hide');
                    }
                });
            }
        });
        $('body').on('click', '#customer_cards_form button[type="submit"]', function (e) {
            e.preventDefault();
            $('#swipe_card').modal('show');
        });
        $('body').on('submit', '#customer_new_card_form', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/save_new_card',
                data: $(this).serialize(),
                success: function (response) {
                    $('#customer_cards').modal('hide');
                    $('#customer_new_card').modal('hide');
                    setTimeout(function () {
                        $('#customer_cards_modal').html(response);
                        $('#customer_cards').modal('show');
                    }, 500);
                }
            });
        });
    },
    saveOrder(status, stripe_id = null) {
        let total = 0;
        let data = [];
        for (let i = 0; i < cart.length; i++) {
            total += parseFloat(cart[i]['total']);
        }
        let date = Math.floor(new Date().getTime()/1000);
        let stripe_id_string = stripe_id !== null ? stripe_id : '';
        let customer_id_string = customer_id !== 0 ? customer_id : '';
        data = {
            stripe_id: stripe_id_string,
            customer_id: customer_id_string,
            date,
            total,
            status,
            products: cart
        };
        $.ajax({
            type: 'POST',
            url: '/orders',
            data: data,
            success: function (response) {
                cart = [];
                order_id = response.data.last_order_id;
                $('#pos .messages').html('<div class="alert alert-success">Order created</div>');
                setTimeout(function () {
                    $('#pos .messages .alert').css('margin-top', '0');
                }, 500);
                $('#pos .cart .products').html('<div class="empty"><i class="fa fa-tag"></i>There’s nothing here yet</div>');
            },
            error: function () {
                $('#pos .messages').html('<div class="alert alert-danger">Create order failed</div>');
            },
            complete: function () {
                setTimeout(function () {
                    $('#pos .messages .alert').css('margin-top', '-70px');
                }, 4500);
                setTimeout(function () {
                    $('#pos .messages').html('');
                }, 5000);
            }
        });
    },
    initOrderEdits() {
        let $this = this;
        $('body').on('click', '.order-edit', function (e) {
            $('.add-order-form-wrapper .form-validation-errors').html('');
            $('#order-date').datetimepicker({
                maxDate: new Date(),
                format: 'YYYY-MM-DD HH:mm:ss',
            });
            e.preventDefault();
            e.stopPropagation();
            $.ajax({
                type: 'GET',
                url: '/get_order',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#order-products-wrapper').html(response.view);
                    $('#discount_checkbox').prop('checked', false);
                    $('#discount').hide();
                    incrementer = response.incrementer;
                    values_incrementers = response.values_incrementers;
                    let item = response.order;
                    if (item) {
                        $('.add-order-form-wrapper .title').html('Edit order');
                        $('#add-order-form input[name="id"]').val(item.id);
                        $('#add-order-form select[name="customer_id"]').val(item.customer_id);
                        $('#add-order-form input[name="store_number"]').val(item.store_number);
                        $('#add-order-form #div-order-number').show();
                        $('#add-order-form input[name="order_number"]').val(item.order_number);
                        $('#add-order-form input[name="date"]').val(item.date);
                        $('#add-order-form select[name="status"]').val(item.status);
                        $('#add-order-form input[name="total"]').val(item.total);
                        $('#add-order-form input[name="weight"]').val(item.weight);
                        if (item.refund) {
                            let refund = item.refund;
                            $('#add-order-form #products-refund').text(parseFloat(refund).toFixed(2));
                        }
                        if (item.discount_amount !== null) {
                            $('#discount_checkbox').prop('checked', true);
                            $('#discount').show();
                            $('#add-order-form input[name="discount_amount"]').val(item.discount_amount);
                            $('#add-order-form select[name="discount_type"]').val(item.discount_type);
                            $('#add-order-form textarea[name="discount_reason"]').val(item.discount_reason);
                        }
                        $('#add-order-modal').modal('show');
                    }
                    $this.recountTotals();
                }
            });
        });
    },
    initOrderDeletes() {
        $('body').on('click', '.order-delete', function () {
            let elem = $(this);
            let $confirm = confirm('You sure want to delete this?');
            if ($confirm) {
                $.ajax({
                    type: 'DELETE',
                    url: '/delete_order',
                    data: ({
                        id: elem.data('id'),
                    }),
                    success: function () {
                        elem.data('id', '');
                        $('#order_table #table').DataTable().ajax.reload(null, false);
                        table.updateMyOrdersTable();
                    }
                });
            }
        });
    },
    initCancelOrder() {
        $('body').on('click', '.order-cancel', function () {
            let elem = $(this);
            let $confirm = confirm('You sure want to cancel this?');
            if ($confirm) {
                $.ajax({
                    type: 'POST',
                    url: '/cancel_order',
                    data: ({
                        id: elem.data('id'),
                    }),
                    success: function () {
                        $('#order_table #table').DataTable().ajax.reload(null, false);
                        table.updateMyOrdersTable();
                    }
                });
            }
        });
    },
    initPrintReceipt() {
        $('body').on('click', '.print-order-receipt', function (e) {
            e.preventDefault();
            window.open('/print-order-receipt/' + $(this).data('id'));
        });
    },
    initSendReceipt() {
        $('body').on('click', '.send-order-receipt', function (e) {
            $('.messages').html('<div class="alert alert-info">Please wait. Sending message...</div>');
            e.preventDefault();
            // The /send-sms-order branch went with the deleted SMS-template feature.
            const url = '/send-order-receipt';
            // The order id comes from the button's own data-id (set where the button is
            // rendered, ~line 135). It used to be read from #order_id_sms, a field only the
            // SMS-template modal ever populated - and that modal was unreachable, so this
            // request went out with an undefined id.
            const orderId = $(this).data('id');
            $.ajax({
                type: 'GET',
                url: url,
                data: ({
                    id: orderId,
                }),
                success: function (response) {
                    $('.messages').html(response);
                },
                error: function (response) {
                    $('.messages').html(response);
                },
                complete: function () {
                    setTimeout(function () {
                        $('.messages').empty();
                    }, 5000);
                }
            });
        });
    },
    initProducts() {
        let $this = this;
        $('body').on('click', '#add-order-add-product', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/get_products_template',
                data: ({
                    increment: incrementer,
                    product_id: $('#add-order-form select[name="order-product"]').val(),
                }),
                success: function (response) {
                    $('#order-products-wrapper').append(response);
                    values_incrementers[incrementer] = 1;
                    incrementer++;
                    $this.recountTotals();
                }
            });
        });
        $('body').on('click', '.products-delete', function (e) {
            e.preventDefault();
            $('#product-' + $(this).data('id')).remove();
        });
        $('body').on('change', '.price-change-check', function () {
            $this.recountTotals();
        });
        $('body').on('click', '#add-order-add-product', function () {
            $this.recountTotals();
        });
        $('body').on('click', '.products-delete', function () {
            $this.recountTotals();
        });
        $('body').on('change', '.price-change-quantity', function () {
            $this.recountTotals();
        });
        $('body').on('change', '#discount_checkbox', function () {
            $this.recountTotals();
        });
        $('body').on('change', '#discount_amount', function () {
            $this.recountTotals();
        });
        $('body').on('change', '#discount_type', function () {
            $this.recountTotals();
        });
    },
    initDiscount() {
        $('body').on('click', '#discount_checkbox', function () {
            if ($("#discount_checkbox").prop("checked")) {
                $('#discount').show();
            } else {
                $('#discount').hide();
            }
        });
    },
    recountTotals() {
        total = 0;
        let $this = this;
        let discount = 0;
        let refund = $('#add-order-form #products-refund').text();
        let subtotals = [];
        let subtotalsPercents = [];
        $('.products-prices').each(function () {
            subtotals[$(this).data('id')] = parseFloat($(this).val());
        });
        $('.price-change-check:not("[data-percent]"):checked').each(function () {
            subtotals[$(this).data('product-id')] += parseFloat($(this).data('price'));
        });
        $('.price-change-check[data-percent]:checked').each(function () {
            subtotalsPercents.push(parseFloat($(this).data('percent')));
        });
        $('.price-change-quantity').each(function () {
            subtotals[$(this).data('product-id')] *= $(this).val();
        });
        subtotals.forEach(function (value, index) {
            if (!isNaN(value)) {
                $('#products-' + index + '-subtotal').html(value.toFixed(2));
                total += parseFloat(value);
            }
        });
        if ($('#discount_checkbox').prop('checked')) {
            if ($('#discount_type').val() === 'amount') {
                discount = $('#discount_amount').val();
            } else {
                discount = total * ($('#discount_amount').val() / 100);
                discount = discount.toFixed(2);
            }
        }
        subtotalsPercents.forEach(function(percent){
            if (percent != 0){
                let modifierPriceChangeValue = Math.abs(total * (percent / 100));
                if (percent < 0){
                    total -= modifierPriceChangeValue;
                }else{
                    total += modifierPriceChangeValue;
                }
            }
        })

        total -= discount;
        total -= refund;
        total = total.toFixed(2);
        $('#products-discount').html(discount);
        $('#products-total').html(total);
        $('body').on('change', '.qty input', function () {
            let input = $(this);
            $this.changeTotal(input.data('index'), input.val(), input.data('product-id'), input.attr('min'), input.attr('max'));
        });
    },
    getModalWithModifiers() {
        let _this = this;
        $('body').on('click', '.tab-content .products .item', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/get_modal_with_modifiers',
                data: ({
                    product_id: $(this).data('product_id'),
                    index: $(this).data('index') ?? -1,
                }),
                success: function (response) {
                    $('#product_modal_form').html(response);
                    $('#product_with_modifiers').modal('show');
                    _this.recountTotals();
                }
            });
        });
        $('body').on('click', '.cart .products .item .fa-edit', function (e) {
            e.preventDefault();
            let data = '';
            let product = cart[$(this).data('index')];
            for (let key in product) {
                if (!key.match(/(price|title)/)) {
                    data += key + '=' + product[key] + '&';
                }
            }
            data += 'index=' + $(this).data('index');
            $.ajax({
                type: 'GET',
                url: '/get_modal_with_modifiers',
                data: data,
                success: function (response) {
                    $('#product_modal_form').html(response);
                    $('#product_with_modifiers').modal('show');
                }
            });
        });
    },
    initQuantity($class) {
        let $this = this;
        $('body').on('click', '.qty .' + $class, function (e) {
            e.preventDefault();
            let product_id = $('.qty .' + $class + '.modal-btn').data('product-id');
            let index;
            let input = $('input.product-id-' + product_id);
            if (!product_id) {
                product_id = e.currentTarget.getAttribute('data-product-id');
                index = parseInt(e.currentTarget.getAttribute('data-index'));
                input = $('input.product-index-' + index);
            }
            let min = input.attr('min');
            let max = input.attr('max');
            let quantity = input.val();
            let new_quantity;
            if ($class === 'plus') {
                new_quantity = parseInt(quantity) + 1;
                if (max === undefined || new_quantity <= max) {
                    input.val(new_quantity);
                }
            } else {
                new_quantity = parseInt(quantity) - 1;
                if (min === undefined || new_quantity >= min) {
                    input.val(new_quantity);
                }
            }
            $this.changeTotal(index, new_quantity, product_id, min, max);
        });
    },
    addToCart() {
        let $this = this;
        $('body').on('click', '#product_with_modifiers #add-product-to-cart', function (e) {
            e.preventDefault();
            $('.qty .minus.modal-btn').data('product-id', '');
            $('.qty .plus.modal-btn').data('product-id', '');
            let form_data = $('body #product_modal_form').serializeArray();
            $.ajax({
                type: 'POST',
                url: '/cart_item_parse',
                async: false,
                data: form_data,
                success: function(response){
                    cart.push(response);
                }
            });
            $this.displayCart();
            $('#product_with_modifiers').modal('hide');
        });
    },
    removeFromCart() {
        let $this = this;
        $('body').on('click', '.qty .minus.disabled', function (e) {
            e.preventDefault();
            let index = $(this).data('index');
            if (cart[index] !== undefined) {
                if (index === 0) {
                    cart.shift();
                } else {
                    cart.splice(index, index);
                }
                $this.displayCart();
                $('#product_with_modifiers').modal('hide');
            }
        });
    },
    displayCart() {
        let items = '<div class="items">';
        let new_total = 0;
        if (cart.length > 0) {
            cart.forEach(function (item, index) {
                let total_price = parseFloat(item['price']);
                let modifier = '';
                if (item['modifiers'] !== undefined){
                    for(let key in item['modifiers']){
                        for(let title in item['modifiers'][key]){
                            if (title != 'selected_modifier_id' && item['modifiers'][key]['selected_modifier_id'] !== undefined){
                                item['modifiers'][key]['selected_modifier_id'].forEach(function(selectedId){
                                    if (item['modifiers'][key][title]['modifier_id'] == selectedId){
                                        modifier += '<div class="modifier d-flex justify-content-between mt-1">' +
                                            '<div>'+ key + '</div>';
                                        if (item['modifiers'][key][title]['price'] !== undefined){
                                            modifier += '<div>'+ item['modifiers'][key][title]['title'] + ' ' + item['modifiers'][key][title]['price'] + '$ ' + '</div>';
                                            total_price += parseFloat(item['modifiers'][key][title]['price']);
                                        }
                                        if (item['modifiers'][key][title]['percent'] !== undefined){
                                            modifier += '<div>'+ item['modifiers'][key][title]['title'] + ' ' + item['modifiers'][key][title]['percent'] + '% ' + '</div>';
                                            if (item['modifiers'][key][title]['percent'] != 0){
                                                let modifierPriceChangeValue = Math.abs(total_price * (item['modifiers'][key][title]['percent'] / 100));
                                                if (item['modifiers'][key][title]['percent'] < 0){
                                                    total_price -= modifierPriceChangeValue;
                                                }else{
                                                    total_price += modifierPriceChangeValue;
                                                }
                                            }
                                        }
                                        modifier += '</div>';
                                    }
                                });

                            }
                        }
                    }
                }

                total_price *= item['quantity'];
                item['total'] = total_price.toFixed(2);
                new_total += parseFloat(total_price.toFixed(2));
                let disabled = '';
                if (parseInt(item['quantity']) === 1) {
                    disabled = 'disabled';
                }
                let modifier_class = 'item';
                if (modifier !== '') {
                    modifier_class = 'modifier_item';
                }
                items += '<div class="item '+modifier_class+'">' +
                    '<div class="d-flex">' +
                    '<div class="title">' + item['title'] + '</div>' +
                    '<div class="qty horizontal">' +
                    '<button data-product-id="' + item['product_id'] + '" data-index="' + index + '" class="minus minus-index-' + index + ' ' + disabled + '"><i class="fa fa-minus"></i></button>' +
                    '<input type="number" data-index="' + index + '" data-product-id="' + item['product_id'] + '" data-price="' + item['price'] + '" name="quantity" class="product-index-' + index + '" min="1" value="' + item['quantity'] + '">' +
                    '<button data-product-id="' + item['product_id'] + '" data-index="' + index + '" class="plus plus-index-' + index + '"><i class="fa fa-plus"></i></button>' +
                    '</div>' +
                    '<div class="total_price">$<span class="total products-total-' + index + '">' + total_price.toFixed(2) + '</span></div>' +
                    '<div class="action"><i data-index="' + index + '" class="fa fa-lg fa-edit-red"></i></div></div>' +
                    '<div class="modifier_separator mt-2"></div>' +
                    modifier +
                    '</div>';
            });
            items += '</div><div class="information"><div class="total row bg-yellow-light"><div class="col-6">Total:</div><div class="col-6 total-price">$' + new_total + '</div></div><div class="btn btn-complete">Complete order</div></div>';
        } else {
            items = '<div class="empty">' +
                '<i class="fa fa-tag"></i>' +
                'There’s nothing here yet' +
                '</div>'
        }
        $('#pos .cart .products').html(items);
    },
    changeTotal(index, new_quantity, product_id, min, max) {
        let $this = this;
        let item = cart[index];
        if (item !== undefined) {
            let total = item.price;
            item['quantity'] = new_quantity;
            if (item['modifiers[0][price]'] !== undefined) {
                let i = 0;
                while (true) {
                    if (item['modifiers[' + i + '][price]'] === undefined) {
                        break;
                    } else if (item['modifiers[' + i + '][selected]'] !== undefined) {
                        let price = parseFloat(item['modifiers[' + i + '][price]']);
                        total = parseFloat(total) + price;
                        i++;
                    } else {
                        i++;
                    }
                }
            }
            cart[index]['total'] = total;
            total = total * new_quantity;
            $('.products-total-' + index).html(total);
        } else {
            $this.recountTotals();
        }
        if (max !== undefined && new_quantity >= parseInt(max)) {
            $('.qty .plus-index-' + index).addClass('disabled');
            $('.qty .plus-' + product_id).addClass('disabled');
        } else {
            $('.qty .plus-index-' + index).removeClass('disabled');
            $('.qty .plus-' + product_id).removeClass('disabled');
        }
        if (min !== undefined && new_quantity <= parseInt(min)) {
            $('.qty .minus-index-' + index).addClass('disabled');
            $('.qty .minus-' + product_id).addClass('disabled');
        } else {
            $('.qty .minus-index-' + index).removeClass('disabled');
            $('.qty .minus-' + product_id).removeClass('disabled');
        }
        $this.displayCart();
    },
    getTotal() {
        let new_total = 0;
        cart.forEach(function (item) {
            let total_price = parseFloat(item['price']);
            let i = 0;
            let is_exist = true;
            while (is_exist) {
                if (item['modifiers[' + i + '][selected]'] === undefined) {
                    is_exist = false;
                } else {
                    total_price += parseFloat(item['modifiers[' + i + '][price]']);
                    i++;
                }
            }
            total_price *= item['quantity'];
            item['total'] = total_price.toFixed(2);
            new_total += parseFloat(total_price.toFixed(2));
        });
        return new_total;
    },
    getTotalByOrderId() {
        setTimeout(function () {
            $.ajax({
                type: 'GET',
                url: 'get_total_by_order_id',
                data: ({
                    order_id: order_id,
                }),
                success: async function (response) {
                    $('#customer_cards_form input[name="total"]').val(response.total);
                    $('#enter_manually_pay_form input[name="total"]').val(response.total);
                    $('#tips input[name="total"]').val(response.total);
                }
            });
        }, 100);
    },
    enterManually() {
        let $this = this;
        $('body').on('click', '.enter-manually', function (e) {
            e.preventDefault();
            let total;
            if (!$this.getTotal()) {
                total = $this.getTotalByOrderId();
            } else {
                total = $this.getTotal();
            }
            $.ajax({
                type: 'GET',
                url: '/get_enter_manually',
                data: ({
                    customer_id: customer_id,
                    total: total,
                }),
                success: function (response) {
                    $('#enter_manually_modal').html(response.view);
                    $('#enter_manually_modal #enter_manually_pay').modal('show');
                }
            });
        });
    },
    pay() {
        let $this = this;
        $('body').on('submit', '#enter_manually_pay', function (e) {
            e.preventDefault();
            $this.getTotalByOrderId(order_id);
            $this.showTipsModal();
        });
        $('body').on('click', '#customer_cards_modal .card', function (e) {
            e.preventDefault();
            $('#tips input[name="card_id"]').val($(this).data('id'));
            $this.getTotalByOrderId(order_id);
            $this.showTipsModal();
        });
    },
    payCard() {
        let $this = this;
        let is_error = false;
        $.ajax({
            type: 'POST',
            url: 'pay_card',
            data: ({
                card_id: $('#tips input[name="card_id"]').val(),
                customer_id: $('#customer_cards_form input[name="customer_id"]').val(),
                total: $('#customer_cards_form input[name="total"]').val(),
            }),
            beforeSend: function () {
                $this.inTheProcess();
            },
            success: function (response) {
                $.ajax({
                    type: 'POST',
                    url: 'change_order',
                    data: ({
                        status: 'Paid',
                        stripe_id: response.result.id,
                        order_id: order_id,
                        customer_id: response.customer_id,
                    })
                });
                $this.successfully();
                customer_id = 0;
            },
            error: function (response) {
                let error = 'Some occurred error';
                if (response.responseJSON.error !== undefined) {
                    error = response.responseJSON.error;
                }
                $this.rejected(error);
                is_error = true;
            },
            complete: function () {
                if (!is_error) {
                    window.open('/print-order-receipt/' + order_id);
                    setTimeout(function () {
                        location.reload();
                    }, 5000);
                }
            }
        });
    },
    payEnter(card_number = false, card_exp = false) {
        let $this = this;
        let is_error = false;
        let data = null;
        if (card_number && card_exp) {
            data = {
                customer_id: "0",
                total: $('#total_for_pay').text(),
                card_number: card_number,
                expiration_date: card_exp,
            };
        }else{
            data = $('#enter_manually_pay_form').serialize();
        }

        $.ajax({
            type: 'POST',
            url: 'pay_enter_manually',
            data: data,
            beforeSend: function () {
                $this.inTheProcess();
            },
            success: function (response) {
                $.ajax({
                    type: 'POST',
                    url: 'change_order',
                    data: ({
                        status: 'Paid',
                        stripe_id: response.result.id,
                        order_id: order_id,
                        customer_id: response.customer_id,
                    })
                });
                $this.successfully();
                customer_id = 0;
            },
            error: function (response) {
                let error = 'Some occurred error';
                if (response.responseJSON.error !== undefined) {
                    error = response.responseJSON.error;
                }
                $this.rejected(error);
                is_error = true;
            },
            complete: function () {
                if (!is_error) {
                    window.open('/print-order-receipt/' + order_id);
                    setTimeout(function () {
                        location.reload();
                    }, 5000);
                }
            }
        });
    },
    refund() {
        let $this = this;
        $('body').on('click', '.refund', function (e) {
            e.preventDefault();
            order_id = $(this).data('order_id');
            $.ajax({
                type: 'GET',
                url: '/get_total_with_refund_by_order_id',
                data: ({
                    order_id: order_id,
                }),
                success: function (response) {
                    $('#refund_modal_form')[0].reset();
                    $('#refund_modal_form input[name="amount"]').attr('max', response.total.toFixed(2));
                    $('#refund_modal').modal('show');
                }
            });
        });
        $('body').on('submit', '#refund_modal_form', function (e) {
            e.preventDefault();
            let is_error = false;
            $.ajax({
                type: 'POST',
                url: '/refund',
                data: ({
                    order_id: order_id,
                    amount: $('#refund_modal_form input[name="amount"]').val(),
                }),
                beforeSend: function () {
                    $this.inTheProcess();
                },
                success: function () {
                    $this.successfully();
                    customer_id = 0;
                },
                error: function (response) {
                    let error = 'Some occurred error';
                    if (response.responseJSON.error !== undefined) {
                        error = response.responseJSON.error;
                    }
                    $this.rejected(error);
                    is_error = true;
                },
                complete: function () {
                    if (!is_error) {
                        setTimeout(function () {
                            location.reload();
                        }, 5000);
                    }
                }
            });
        });
    },
    payFromMyOrders() {
        $('body').on('click', '.not-paid', function (e) {
            e.preventDefault();
            order_id = $(this).data('order_id');
            customer_id = $(this).data('customer_id');
            $.ajax({
                type: 'GET',
                url: 'get_customer',
                data: ({
                    id: customer_id,
                }),
                success: function (response) {
                    if (response.customer !== '') {
                        $('#pay_order_modal_form input[name="name"]').val(response.customer.first_name + ' ' + response.customer.last_name);
                        $('#pay_order_modal_form input[name="name"]').attr('readonly', true);
                        $('#pay_order_modal_form input[name="phone"]').val(response.customer.phone);
                        $('#pay_order_modal_form input[name="phone"]').attr('readonly', true);
                    }
                    $('#pay_order_modal_form button[type="submit"]').addClass('order-created');
                    $('#pay_order_modal_form .pay-later').attr('hidden', true);
                    $('#pay_order_modal').modal('show');
                    customer_id = 0;
                }
            });
        });
    },
    inTheProcess() {
        $('#pay_result_modal .modal-body').html(
            '<div class="title">In the process</div>' +
            '<div class="result">' +
            '<i class="spinner fa fa-reload"></i>' +
            '</div>'
        );
        $('#pay_result_modal').modal('show');
    },
    successfully(show_modal = false) {
        $('#pay_result_modal .modal-body').html(
            '<div class="title">Successfully</div>' +
            '<div class="result">' +
            '<i class="fa fa-success"></i>' +
            '</div>'
        );
        if (show_modal) {
            $('#pay_result_modal').modal('show');
        }
    },
    rejected(error, show_modal = false) {
        $('#pay_result_modal .modal-body').html(
            '<div class="title">Rejected</div>' +
            '<div class="subtitle">' + error + '</div>' +
            '<div class="result">' +
            '<i class="fa fa-error"></i>' +
            '</div>'
        );
        if (show_modal) {
            $('#pay_result_modal').modal('show');
        }
    },
    showTipsModal() {
        let $this = this;
        $('#tips_total').text('0.00');
        $('#tips input[name="total"]').val('0.00');
        $('.tips_percent').removeClass('active');
        $('#tips #sign').show();
        $('#tips').modal('show');

        setTimeout(function() {
            $this.signatureInit();
        }, 500);
    },
    setTips() {
        $('body').on('click', '.tips_percent', function(e) {
            e.preventDefault();
            $('.tips_percent').removeClass('active');
            $(this).addClass('active');
            let tips = $(this).data('value') * $('#tips input[name="total"]').val() / 100;
            $('#tips_total').text(tips.toFixed(2));
        });
    },
    saveTips() {
        let $this = this;
        $('body').on('click', '#tips #submit', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/save-tips',
                data: ({
                    order_id: order_id,
                    tips: $('#tips_total').text(),
                    signature: signature,
                }),
                success: function () {
                    let method = $('input[name="payment"]:checked').val();
                    switch (method) {
                        case 'card':
                            if ($('#tips input[name="card_id"]').val() === '') {
                                $this.payEnter();
                            }else{
                                $this.payCard();
                            }
                            break;
                        case 'cash':
                            $this.saveCashFromOrder();
                            break;
                    }
                },
            });
        });
    },
    signatureInit() {
        let canvas = document.querySelector("#canvas");
        let context = canvas.getContext('2d');
        initialize();
        $('#tips #submit').prop('disabled', true);

        let signaturePad = new SignaturePad(canvas);
        signaturePad.clear();

        $('body').on('mousemove', '#tips #canvas', function() {
            signature = signaturePad.toDataURL();
            $('#tips #submit').prop('disabled', false);
        });
        $('body').on('touchmove', '#tips #canvas', function() {
            signature = signaturePad.toDataURL();
            $('#tips #submit').prop('disabled', false);
        });


        function initialize() {
            window.addEventListener('resize', resizeCanvas, false);
            resizeCanvas();
        }

        function resizeCanvas() {
            canvas.width = $('#tips #canvas').width();
            canvas.height = $('#tips #canvas').height();
            context.strokeRect(0, 0, canvas.width, canvas.height);
        }
    },
    hideSignPlaceholder() {
        $('body').on('mousedown', '#tips #canvas', function(e) {
            $('#tips #sign').hide();
        });
        $('body').on('touchstart', '#tips #canvas', function(e) {
            $('#tips #sign').hide();
        });
    },
    checkedCash() {
        $('body').on('change', '#cash', function(e) {
            if(this.checked) {
                $('.pay-buttons button[type="submit"]').text('Pay')
            }
        });
        $('body').on('change', '#card', function(e) {
            if(this.checked) {
                $('.pay-buttons button[type="submit"]').text('Next')
            }
        });
    },
}
